export const isOptionItm = (item, stockPrice) => {
    if (!item || Number(item.counter) !== 1) {
        return false;
    }

    const strike = Number(item.strike) || 0;
    const price = Number(stockPrice) || 0;

    if (!strike || !price) {
        return false;
    }

    if (item.option_kind === 'CALL') {
        return price > strike;
    }

    if (item.option_kind === 'PUT') {
        return price < strike;
    }

    return false;
};

export const isPositionItm = (item, stockPrice, subOrders = []) => {
    if (isOptionItm(item, stockPrice)) {
        return true;
    }

    return subOrders.some((sub) => {
        if (isOptionItm(sub, stockPrice)) {
            return true;
        }

        const nested = Array.isArray(sub.sub_order) ? sub.sub_order : [];
        return nested.some((leg) => isOptionItm(leg, stockPrice));
    });
};
